"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = exports.createUseFirestoreConnect = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray")),
    _react = require("react"),
    _utils = require("./utils"),
    _useFirestore = _interopRequireDefault(require("./useFirestore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var createUseFirestoreConnect = function createUseFirestoreConnect() {
  return function (dataOrFn) {
    var firestore = (0, _useFirestore.default)(),
        inputAsFunc = (0, _utils.createCallable)(dataOrFn),
        data = inputAsFunc(),
        payload = (0, _react.useMemo)(function () {
      if (!data) return null;
      if ((0, _isArray2.default)(data)) throw new Error("Array isn't allowed inside useFirestoreConnect hook.");
      return [data];
    }, [data]);
    (0, _react.useEffect)(function () {
      if (null !== data) return firestore.setListeners(payload), function () {
        firestore.unsetListeners(payload);
      };
    }, [data]);
  };
};

exports.createUseFirestoreConnect = createUseFirestoreConnect;

var _default = createUseFirestoreConnect();

exports.default = _default;